import { muiTheme } from 'genesis-suite/theme'
import { createTheme } from '@mui/material/styles'

const defaultTheme = muiTheme()

export const theme = createTheme({
    ...defaultTheme,
    palette: {
        ...defaultTheme.palette,
        primary: {
            main: '#F15E3F',
        },
    },
    custom: {
        ...defaultTheme.custom,
        fieldWidth: 200,
        topNavHeight: 50,
    },
})
